import { buildShipperBreakdown } from 'src/components/dispatch/detailPanel/shipperBreakdown';
import { UnassignedItem } from 'src/entities/dispatch';
import { ShipmentOrderLegRunForPlanEntity } from 'src/entities/ShipmentOrderLegRun.entity';

import { buildDisplayInfoFields } from './displayInfoFields';
import { LaneGroup } from './laneGroups';

/**
 * レーンの詳細パネルに渡す 1 件。配下の伝票をまとめた合成 item。
 *
 * 代表 1 件をそのまま渡すと、他の伝票の数量と荷主が詳細から消える。
 * 地点そのものの情報（名前・住所・座標）は代表から採る — レーンは同じ区間の集約なので
 * どれも同じ値になる。
 */
export function buildLaneDetailItem(group: LaneGroup): UnassignedItem {
  const [head] = group.items;
  const legRuns = group.items
    .map((item) => item.source)
    .filter((source): source is ShipmentOrderLegRunForPlanEntity => source != null);

  const orderIds = new Set(
    legRuns.map((lr) => lr.shipment_order_id).filter((id): id is number => typeof id === 'number'),
  );
  const shippers = [...new Set(legRuns.map((lr) => lr.shipper_name).filter(Boolean))];

  return {
    ...head,
    // 詳細パネルは selection の id で開閉を判定する。レーンごとに変わる値にする
    id: group.key,
    // 編集は案件でなくレーンを開く（配下の伝票が複数あり案件が 1 つに決まらない）
    isLaneGroup: true,
    cases: group.totalCases,
    weight: group.totalWeight,
    volume: group.totalVolume,
    invoiceCount: orderIds.size,
    shippers,
    shipperBreakdown: buildShipperBreakdown(legRuns),
    // 代表 1 件ではなくレーン配下の全伝票から組み立てる（head の値だけだと他の伝票が消える）
    ...buildDisplayInfoFields(legRuns),
  };
}
